module.exports = __webpack_public_path__ + "img/testimonial-5-61x61_1testimonial-5-61x61.23af9191.png";